/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Features_TitleInputs */

const en_seo_features_title = /** @type {(inputs: Seo_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features for personal trainers`)
};

const pl_seo_features_title = /** @type {(inputs: Seo_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje dla trenerów personalnych`)
};

/**
* | output |
* | --- |
* | "Features for personal trainers" |
*
* @param {Seo_Features_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_features_title = /** @type {((inputs?: Seo_Features_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Features_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_features_title(inputs)
	return en_seo_features_title(inputs)
});